import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
	faArrowTrendDown,
	faArrowTrendUp,
	faBasketShopping,
	faBolt,
	faBrain,
	faBriefcase,
	faBuilding,
	faBuildingColumns,
	faBullseye,
	faCalculator,
	faCalendarCheck,
	faChartColumn,
	faChartLine,
	faChartPie,
	faCircleDown,
	faCloudRain,
	faCoins,
	faDoorOpen,
	faFileContract,
	faFlag,
	faFlask,
	faGavel,
	faGlobe,
	faHandHoldingDollar,
	faHandshake,
	faHourglassHalf,
	faIndustry,
	faLandmark,
	faLightbulb,
	faMicrochip,
	faMoneyBillWave,
	faPercent,
	faPeopleGroup,
	faPlane,
	faPrint,
	faReceipt,
	faRobot,
	faRocket,
	faSackDollar,
	faScaleBalanced,
	faScissors,
	faServer,
	faShieldHalved,
	faSkull,
	faStopwatch,
	faTag,
	faTemperatureHalf,
	faTriangleExclamation,
	faTruck,
	faUsers,
	faUserTie,
} from "@fortawesome/free-solid-svg-icons";

/** Node icons (Font Awesome solid), by name. Names are what the grammar stores in `icon`. */
export const ICONS: Record<string, IconDefinition> = {
	"bolt": faBolt,
	"arrow-trend-down": faArrowTrendDown,
	"arrow-trend-up": faArrowTrendUp,
	"circle-down": faCircleDown,
	"triangle-exclamation": faTriangleExclamation,
	"cloud-rain": faCloudRain,
	"landmark": faLandmark,
	"rocket": faRocket,
	"door-open": faDoorOpen,
	"scissors": faScissors,
	"handshake": faHandshake,
	"flask": faFlask,
	"gavel": faGavel,
	"flag": faFlag,
	"calendar-check": faCalendarCheck,
	"file-contract": faFileContract,
	"shield-halved": faShieldHalved,
	"robot": faRobot,
	"brain": faBrain,
	"microchip": faMicrochip,
	"server": faServer,
	"globe": faGlobe,
	"plane": faPlane,
	"truck": faTruck,
	"lightbulb": faLightbulb,
	"skull": faSkull,
	"chart-line": faChartLine,
	"chart-column": faChartColumn,
	"chart-pie": faChartPie,
	"money-bill-wave": faMoneyBillWave,
	"sack-dollar": faSackDollar,
	"coins": faCoins,
	"hand-holding-dollar": faHandHoldingDollar,
	"calculator": faCalculator,
	"percent": faPercent,
	"building-columns": faBuildingColumns,
	"building": faBuilding,
	"industry": faIndustry,
	"print": faPrint,
	"basket-shopping": faBasketShopping,
	"user-tie": faUserTie,
	"users": faUsers,
	"people-group": faPeopleGroup,
	"briefcase": faBriefcase,
	"receipt": faReceipt,
	"bullseye": faBullseye,
	"stopwatch": faStopwatch,
	"hourglass-half": faHourglassHalf,
	"temperature-half": faTemperatureHalf,
	"scale-balanced": faScaleBalanced,
	"tag": faTag,
};

export const EVENT_ICONS = [
	"bolt",
	"arrow-trend-down",
	"arrow-trend-up",
	"triangle-exclamation",
	"cloud-rain",
	"landmark",
	"rocket",
	"door-open",
	"scissors",
	"handshake",
	"gavel",
	"flag",
	"calendar-check",
	"file-contract",
	"shield-halved",
	"robot",
	"brain",
	"microchip",
	"globe",
	"flask",
	"skull",
	"circle-down",
	"lightbulb",
	"plane",
];
export const METRIC_ICONS = [
	"chart-line",
	"chart-column",
	"chart-pie",
	"money-bill-wave",
	"sack-dollar",
	"coins",
	"hand-holding-dollar",
	"calculator",
	"percent",
	"building-columns",
	"building",
	"industry",
	"users",
	"people-group",
	"user-tie",
	"briefcase",
	"receipt",
	"bullseye",
	"stopwatch",
	"hourglass-half",
	"temperature-half",
	"server",
	"truck",
	"basket-shopping",
	"print",
	"scale-balanced",
	"tag",
];

export const DEFAULT_ICON = { event: "bolt", metric: "chart-line" } as const;

/** For migrating stored emoji to icon names. */
export const EMOJI_TO_ICON: Record<string, string> = {
	"🌧️": "cloud-rain",
	"🔻": "circle-down",
	"📈": "chart-line",
	"📉": "arrow-trend-down",
	"🏛️": "landmark",
	"💵": "money-bill-wave",
	"✖️": "calculator",
	"🏦": "building-columns",
	"🚀": "rocket",
	"🏢": "building",
	"🏭": "industry",
	"🖨️": "print",
	"🧺": "basket-shopping",
	"💰": "sack-dollar",
	"🧑‍💼": "user-tie",
	"🧾": "receipt",
	"🎯": "bullseye",
	"👥": "users",
	"🚪": "door-open",
	"✂️": "scissors",
	"⚠️": "triangle-exclamation",
	"⚡": "bolt",
	"🤝": "handshake",
	"🧪": "flask",
	"📊": "chart-column",
	"⏱️": "stopwatch",
	"🌡️": "temperature-half",
	"☠️": "skull",
};

export function iconDef(name: string | undefined, kind: "event" | "metric"): IconDefinition {
	return (name && ICONS[name]) || ICONS[DEFAULT_ICON[kind]];
}
